import epub, { Content, Options } from "@surge-global-engineering/epub-gen-browser";

export const exportEpub = async (
  options: Options, 
  content: Content
): Promise<Buffer> => {
  const epubBlob = await epub(options, content);
  return epubBlob;
};
